import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Layout } from 'lucide-react';
import { StepWrapper } from '../StepWrapper';
import { Settings } from '@/pages/Settings';

interface StepPlannerGroupsProps {
  onNext: () => void;
  onBack: () => void;
  onSkip: () => void;
}

export function StepPlannerGroups({ onNext, onBack, onSkip }: StepPlannerGroupsProps) {
  const [showSettings, setShowSettings] = useState(false);

  const nudge = showSettings
    ? 'Organise your synced resources into logical teams or departments. You can always update groups from Settings → Planner Group Setup.'
    : undefined;

  return (
    <StepWrapper
      onNext={onNext}
      onBack={onBack}
      onSkip={onSkip}
      nextLabel="Finish Setup →"
      nudgeMessage={nudge}
    >
      {showSettings ? (
        /*
          Settings has `h-full overflow-y-auto` at its root. Give it a min-height
          so it doesn't collapse when the parent has no fixed height.
        */
        <div className="min-h-[600px] overflow-hidden">
          <Settings initialTab="group-setup" embeddedMode={true} />
        </div>
      ) : (
        /* Empty state */
        <div className="flex min-h-[360px] flex-col items-center justify-center p-8 text-center">
          <div
            className="mb-5 flex h-16 w-16 items-center justify-center rounded-2xl"
            style={{ backgroundColor: 'rgba(26, 138, 138, 0.1)' }}
          >
            <Layout className="h-8 w-8" style={{ color: '#1a8a8a' }} />
          </div>
          <h3 className="mb-2 text-lg font-semibold text-foreground">
            Planner Groups (Optional)
          </h3>
          <p className="mb-6 max-w-md text-sm text-muted-foreground leading-relaxed">
            Planner groups let you organise your synced resources into logical teams or
            departments on the planner. This is optional — you can set it up at any time
            from{' '}
            <span className="font-medium text-foreground">
              Settings → Planner Group Setup
            </span>
            .
          </p>
          <Button
            size="sm"
            onClick={() => setShowSettings(true)}
            className="text-white"
            style={{ backgroundColor: '#1a8a8a' }}
          >
            Set Up Planner Groups Now
          </Button>
        </div>
      )}
    </StepWrapper>
  );
}
